import React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import cn from 'classnames'
import st from './Loading.scss'

const Loading = ({absolute}) => (
  <div className={cn(st.core, {[st.absolute]: absolute})}>
    <CircularProgress style={{ color: '#ff8201' }} />
  </div>
)

Loading.propTypes = {
  absolute: PropTypes.bool
}

Loading.defaultProps = {
  absolute: false
}

export default Loading


// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js